import { Button } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from './constants';

export const ViewSettingsButton = styled(Button)`
  && {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    padding: 4px 8px;
    min-width: auto;
    color: #000;
    font-weight: 400;
    font-size: 13px;

    &:hover,
    &:focus,
    &:active {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    .MuiButton-startIcon {
      margin-right: 8px;
      margin-bottom: 3px;
      margin-left: 0;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 50%;
      padding: 2px;
      display: flex;
      align-items: center;
      justify-content: center;

      .MuiSvgIcon-root {
        color: ${COLORS.white};
        font-size: 10px;
      }
    }

    .MuiButton-label,
    & > span:not(.MuiButton-startIcon) {
      margin-top: 20px;
    }

    .MuiTouchRipple-root,
    &::before,
    &::after {
      display: none !important;
    }
  }
`;
